import type { HelpFile } from '../../types/help'
import { RestrictionRuleViolationsDashboardTestIds } from '../../../testids/RestrictionRuleViolationsDashboardTestIds'

export const restrictionRuleViolationsDashboardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleViolationsDashboardTestIds.violationsDashboard]: 'Identitäten, die derzeit gegen eine oder mehrere Restriktionsregeln verstoßen — sie halten Zugriffsprofile, die nicht kombiniert werden dürfen.',
    [RestrictionRuleViolationsDashboardTestIds.colDeniedProfiles]: 'Verbotene Zugriffsprofile, die die Identität aktuell hält.',
    [RestrictionRuleViolationsDashboardTestIds.colDetectedAt]: 'Zeitpunkt der ersten Erkennung des Verstoßes.',
    [RestrictionRuleViolationsDashboardTestIds.colName]: null,
    [RestrictionRuleViolationsDashboardTestIds.colRuleName]: 'Restriktionsregel, gegen die diese Identität aktuell verstößt.',
  },
}
